import { render, staticRenderFns } from "./MeterUserinfoTransferRecordForm.vue?vue&type=template&id=ebee24b0"
import script from "./MeterUserinfoTransferRecordForm.vue?vue&type=script&lang=js"
export * from "./MeterUserinfoTransferRecordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports